<template>
	<div class="contact">
		<div class="container">
			<div class="contact-left">
				<h1>广州天图极客网络科技有限公司</h1>
				<p>电话：15296377252</p>
	     		<p>E-mail:15296377252</p>
	     		<p>地址：广州市白云区YH城二楼201</p>
	     		<p>楼宇对讲业务模块：8008008820</p>
	     		<p>智能家居业务模块：8008008820</p>
	     		<p>视频门禁业务模块：8008008820</p>
	     		
	     		<div class="erweima">
	     			<div class="center-left">
		     			<img src="../../../../../static/img/kefu.jpg" />
		     			<p>关注微信公众号</p>
		     		</div>
		     		<div class="center-right">
		     			<img src="../../../../../static/img/kefu.jpg" />
		     			<p>关注更多资讯</p>
		     		</div>
	     		</div>
	     		
			</div>
			<div class="contact-right">
				<img src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1551692278598&di=ce151d4fd5b7521477f0e88add68bf30&imgtype=0&src=http%3A%2F%2Fpic32.photophoto.cn%2F20140808%2F0006019019886851_b.jpg"/>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:'contact'
			}
		}
		
	}
</script>

<style lang="less" scoped="scoped">
.contact{
	margin-top: 70px;
	margin-bottom: 70px;
	height: 550px;
	.contact-left{
		float: left;
		display: inline-block;
		width: 40%;
		height: 100%;
		h1{
			font-size: 33px;
			color: #146BFF;
			margin-bottom: 30px;
		}
		p{
			font-size: 18px;
			font-family: "微软雅黑";
			padding: 5px;
		}
		.erweima{
			margin-top: 50px;
			width: 100%;
			height: 250px;
			
			.center-left{
				display: inline-block;
				text-align:center;
				img{
					width: 180px;
					height: 180px;
				}
			}
			.center-right{
				display: inline-block;
				text-align:center;
				img{
					width: 180px;
					height: 180px;
				}
			}
			
		}
	}
	.contact-right{
		float: right;
		display: inline-block; 
		width: 58%;
		height: 100%;
		img{
			padding-top: 50px;
			height: 100%;
			width: 100%;
		}
		
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ContactUs/Ccom/Contact.vue